import { render } from "./StatusInProgress.svg?vue&type=template&id=3dec4914"
const script = {}
script.render = render

export default script